import React from 'react'
import { Edit, SaveButton, SimpleForm, TextInput, Toolbar, translate } from 'react-admin'
import { containsRestrictedFieldName } from '../models/restrictedNames'

const SaveOnlyToolbar = (props) => (
  <Toolbar {...props}>
    <SaveButton disabled={props.invalid} />
  </Toolbar>
)

const AssetTypeEdit = ({ accessible, dispatch, recordLiveValues, roles, translate, ...props }) => {
  const toolbar = <SaveOnlyToolbar />
  const validateName = (value) =>
    !containsRestrictedFieldName(value) ? undefined : translate('main.restricted_field_name')

  return (
    <Edit {...props}>
      <SimpleForm toolbar={toolbar}>
        <TextInput source="name" resettable validate={validateName} />
      </SimpleForm>
    </Edit>
  )
}

export default translate(AssetTypeEdit)
